import { useState, useEffect } from 'react';
import { DEFAULT_SYSTEM_PROMPT } from '../constants/prompts';

export const useCustomPrompt = () => {
  const [customPrompt, setCustomPrompt] = useState(() => {
    const saved = localStorage.getItem('customSystemPrompt');
    return saved || DEFAULT_SYSTEM_PROMPT;
  });
  const [promptInputValue, setPromptInputValue] = useState(customPrompt);
  const [showPromptEditor, setShowPromptEditor] = useState(false);

  // Sync prompt input value with custom prompt
  useEffect(() => {
    setPromptInputValue(customPrompt);
  }, [customPrompt]);

  const updateCustomPrompt = () => {
    setCustomPrompt(promptInputValue);
    localStorage.setItem('customSystemPrompt', promptInputValue);
    setShowPromptEditor(false);
    console.log('✅ Custom prompt updated and saved');
  };

  const resetToDefaultPrompt = () => {
    setCustomPrompt(DEFAULT_SYSTEM_PROMPT);
    setPromptInputValue(DEFAULT_SYSTEM_PROMPT);
    localStorage.removeItem('customSystemPrompt');
    setShowPromptEditor(false);
    console.log('✅ Prompt reset to default');
  };

  return {
    customPrompt,
    promptInputValue,
    setPromptInputValue,
    showPromptEditor,
    setShowPromptEditor,
    updateCustomPrompt,
    resetToDefaultPrompt
  };
};
